export const TUTORIAL_STEPS = [
  {
    id: 'start',
    title: 'Getting Started',
    description:
      'Begin your internship journey here! This page will teach you about the application process.',
    placement: 'right',
    image: '/maincar.png',
  },
  {
    id: 'roles',
    title: 'Unlock more lessons',
    description: "You'll unlock this lesson and more once you complete the previous lesson!",
    placement: 'right',
    image: '/thinkingcar.png',
  },
  {
    id: 'navbar',
    title: 'Unlock Features',
    description:
      'Completing certain lessons will allow you to unlock new practice features like application tracking, interview prep, and more!',
    placement: 'top',
    image: '/maincar.png',
  },
];
